const o = {
  lat: 0,
  lng: 0,
  get center() {
    return [this.lat, this.lng];
  },
  zoom: 3,
  nearZoom: 10,
  levelDeepPolygon: 1
}, t = {
  className: "marker",
  iconSize: [20, 30],
  iconAnchor: [10, 30]
}, e = {
  color: "#1976d2",
  errorColor: "#C10015",
  stroke: !0,
  weight: 3,
  opacity: 1,
  fill: !0
}, r = {
  position: "topright",
  draw: {
    polygon: {
      allowIntersection: !1,
      drawError: {
        color: e.errorColor
      },
      shapeOptions: e
    },
    polyline: !1,
    circle: !1,
    rectangle: {
      showArea: !1,
      shapeOptions: e
    },
    marker: !1,
    circlemarker: !1
  },
  edit: {
    remove: !1
  }
}, l = {
  maxZoom: 24,
  type: "roadmap",
  styles: [
    { featureType: "poi", elementType: "labels", stylers: [{ visibility: "off" }] },
    { featureType: "transit", elementType: "labels", stylers: [{ visibility: "off" }] }
  ]
};
export {
  o as DefaultOptions,
  r as DrawOptions,
  l as GoogleMutantOptions,
  t as MarkerOptions,
  e as ShapeOptions
};
